import axios from 'axios'

let baseurl = process.env.VUE_APP_CURENV === "development" ? "/api" : '/api'

// 创建 axios 实例
let http = axios.create({
    baseURL: baseurl,
    timeout: 30000,
})


// 添加请求拦截器
http.interceptors.request.use(config => {

    config.headers['Tenant-Id'] = '000000'
    config.headers['Authorization'] = 'Basic c2FiZXI6c2FiZXJfc2VjcmV0'
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    if (config.method === 'post' || config.method === 'put') {
        // post、put 提交时，将对象转换为string, 为处理Java后台解析问题
        // config.data = JSON.stringify(config.data)
    } else if (config.method === 'get') {
        // 给GET 请求后追加时间戳， 解决IE GET 请求缓存问题
        // let symbol = config.url.indexOf('?') >= 0 ? '&' : '?'
        // config.url += symbol + '_=' + Date.now()
        // config.url
    }

    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof(value) !== "undefined") {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        url += subPart + encodeURIComponent(value[key]) + "&";
                    }
                } else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }

    // 请求发送前进行处理
    return config
}, error => {
    // 请求错误处理
    return Promise.reject(error)
})

// 添加响应拦截器
http.interceptors.response.use(response => {
    let { data } = response
    // console.log('data >>> ', data)
    return data
}, error => {
    return Promise.reject(error)
})

/**
 * 创建统一封装过的 axios 实例
 * @return {AxiosInstance}
 */
export default function () {
    return http
}
